import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { AccountService } from 'src/app/services/account.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ModalController } from '@ionic/angular';
import { SessionDataService } from 'src/app/services/session-data.service';
import { VerificationComponent } from '../verification/verification.component';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { LearnMoreTravelInsuranceComponent } from '../learn-more-travel-insurance/learn-more-travel-insurance.component';
import { ProRataPricesModalComponent } from '../pro-rata-prices-modal/pro-rata-prices-modal.component';
import * as moment from 'moment';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { ThrowStmt } from '@angular/compiler';
import { SuccessComponent } from '../success/success.component';
import { FormControl, Validators } from '@angular/forms';
import { ArenaProDataService } from 'src/app/services/arena-pro-data.service';
import { GamerFormData } from 'src/app/models/gamer-form-data';

@Component({
  selector: 'app-arena-pro',
  templateUrl: './arena-pro.component.html',
  styleUrls: ['./arena-pro.component.scss'],
})
export class ArenaProComponent implements OnInit {
  model: NgbDateStruct;
  public sku: any;
  public agreedOnterms = false;
  public mobileNumber: any;
  public isExpended: boolean = false;
  public quantity = 1;
  autoRenew: boolean = false;
  public price: string = '';
  currentAccount: any;
  isATPostpaid: boolean;
  countries: any;
  callForwardNumber: any;
  selectedFregement: any = 0;
  sDate: any;
  start: any;
  minDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };
  end: any;
  countrycode: any;
  isBridgeSKU: boolean;
  paymentMethod: any;
  categoryDetail: any;
  addon: any;
  smilePointsOfUser: number;
  userInfo: any;
  isArabic: boolean;
  accountId: string;
  LoggedIn = false;
  isUserLoggedIn: boolean = false;
  selectedCategory: any;
  isHomeBound: boolean;
  isprimary: any;
  disabledSmilePoints: boolean = true;
  showSmilesPoints: boolean;
  allowPayWithLoyaltyPaymentMode: boolean = false;
  isControlLine: boolean = false;
  addonCMSUrl: string;
  ismobileScreen: boolean;

  reminderDateTime: any;
  reminderDate: any;
  reminderTime: any;
  reminderAmPm: any;
  timeArray: any = ['12:00', '12:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30', '06:00'
    , '06:30', '07:00', '07:30', '08:00', '082:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30'];

  amPm: any = ['AM', 'PM'];
  currentBalance: number = 0;
  subscribeDisabled: boolean = false;
  AlreadyOpenedVerificationPop: boolean;
  skuAddonDetails: any;
  travelInsuranceAdded: boolean = false;
  isTravelInsuranceAddon: boolean = false;
  proratedData:any[]=[];
  proratadValues:any[]=[];
  lang:any='';
  exists=false;
  subscribedAddonList=[];
  recommendedAddonsSkus: any[];
  userEnv:any;
  
  gamerId: FormControl = new FormControl('',[Validators.pattern('^[A-Za-z0-9@!-_]+$'),Validators.maxLength(190),Validators.required]);
  email: FormControl = new FormControl('',[Validators.email,Validators.required]);
  confirmEmail: FormControl = new FormControl('',[Validators.required,Validators.email]);
  gamerProfileExist:boolean = false;
  editForm : boolean = false;
  profileData : any = '';
  usernameNotAvailable : boolean = false;
  emailNotAvailable : boolean = false;
  showOptionalDevices : boolean = false;
  selectedDevice:any;
  showDeviceStocks: boolean = false;
  constructor(
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private ACCS: AccountService,
    private SS: SubjectService,
    private PS: ProductService,
    private cdr: ChangeDetectorRef,
    private GAS: GoogleAnalyticsService,
    private translate: TranslateService,
    private aRoute: ActivatedRoute,
    private modalController: ModalController,
    private SDS: SessionDataService,
    private AAS: AdobeAnalyticsService,
    private appInitService: ApplicationInitializationService,
    private AS: AccountService,
    public router: Router,
    private APDS:ArenaProDataService
  
  ) {
    this.lang = this.UTS.getLocaleLanguage();
    this.proratadValues = this.appInitService?.environmentConfig?.B2C_PRORATA_TOTAL_VALUE;
    this.SS.sku.subscribe((main) => {
      if (main && main.name && main.value) {
        this.addon = main.name;
        this.categoryDetail = main.value;
      }
    });
    this.SS.skuBackendIdDetail.subscribe(x=>{
     if (x!=null)
     {
      if(x?.backendId!=null)
      {
        let subscribedList=JSON.parse(localStorage.getItem('subscribedList'));
        if(subscribedList!=null)
        {
          let filtered=subscribedList?.filter(res=>res==x.backendId);
          if(filtered!=null&&filtered.length>0)
          {
            this.exists=true;
        this.cdr.detectChanges();
          }
          else{
            this.exists=false;
            this.cdr.detectChanges();
          }
        }
     
      }
     }
    })
    this.SS.recommendedAddonsSkus.subscribe((r)=>{ 
      if(r && r.length > 0) {
      this.recommendedAddonsSkus = [];
      this.recommendedAddonsSkus = r;
      for (let i = 0; i < this.recommendedAddonsSkus.length; i++) {
          const skuId = this.recommendedAddonsSkus[i];
          if(skuId == this.sku?.skuId){
            const recommend = {
              recommended : true,
            }
            this.sku = {...this.sku, ...recommend};
          }
        }
      }
    });
    
    this.SS.arenaProAddonEmailNotAvailable.subscribe((r) => {
      if (r) {
        this.emailNotAvailable = true;
      }
    });
    
    this.SS.arenaProAddonUsernameNotAvailable.subscribe((r) => {
      if (r) {
        this.usernameNotAvailable = true;
      }
    });
    
    this.SS.arenaProAddonEmailAvailable.subscribe((r) => {
      if (r) {
        this.emailNotAvailable = false;
      }
    });
    
    this.SS.arenaProAddonUsernameAvailable.subscribe((r) => {
      if (r) {
        this.usernameNotAvailable = false;
      }
    });
  }

  ngOnInit() {
    this.ismobileScreen = this.UTS.isMobileDevice();
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.userEnv = this.UTS.getENV();
    this.SS.account.subscribe((r) => {
      this.mobileNumber = r;
      this.checkingGamingProfile(this.mobileNumber);
    });
  }
  ngDestory() { }

 async  ngAfterContentInit() {
    this.userInfo = await this.ACCS.getUInfo();
    this.selectedCategory = this.SKUDS.getSelectedCategory();
    if (
      this.selectedCategory &&
      this.selectedCategory.categoryId &&
      this.selectedCategory.categoryId == AppSettings.HOME_BOUND
    ) {
      this.isHomeBound = true;
      this.cdr.detectChanges();
    } else {
      this.isHomeBound = false;
      this.cdr.detectChanges();
    }
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.subCategory) {
        const subCategory = q.subCategory;
        if (subCategory == AppSettings.CONTROL_LINE) {
          this.isControlLine = true;
          if (
            this.selectedCategory &&
            this.selectedCategory.categoryId &&
            this.selectedCategory.categoryId == AppSettings.HOME_BOUND
          ) {
            this.isHomeBound = true;
            this.cdr.detectChanges();
          }
        }
      }
    });
    if (this.userInfo && this.userInfo.mainServiceAccountNo) {
      let count = 0, isBlockCall = false;
      this.SS.currentAccount.subscribe((r) => {
        this.currentAccount = r;
        localStorage.setItem('currentAccount', JSON.stringify(this.currentAccount));
        if (r && localStorage.getItem('currentAccount')) {
          count++;
          const current_user = JSON.parse(localStorage.getItem('currentAccount'));
          this.currentAccount = current_user;
          this.isUserLoggedIn = true;
          this.mobileNumber = this.currentAccount.mobileNumber
            ? this.currentAccount.mobileNumber
            : this.currentAccount.accountNo
              ? this.currentAccount.accountNo
              : (this.currentAccount.mobileNumber)
                ? this.currentAccount.mobileNumber
                : '';

          this.LoggedIn = true;
          if (count == 1 && isBlockCall == false) {
            isBlockCall = true;
            this.getAccountTypeLogin();
            this.getSmilePoint();
          }
        }
        this.checkingGamingProfile(this.mobileNumber);
      });
    } else {
      this.SS.account.subscribe((r) => (this.mobileNumber = r));
      if (localStorage.getItem('currentAccount')) {
        const current_user = JSON.parse(localStorage.getItem('currentAccount'));
        this.currentAccount = current_user;
        this.isUserLoggedIn = true;
        this.mobileNumber = this.currentAccount.mobileNumber
          ? this.currentAccount.mobileNumber
          : this.currentAccount.accountNo
            ? this.currentAccount.accountNo
            : (this.currentAccount.mobileNumber)
              ? this.currentAccount.mobileNumber
              : '';
              this.getAccountTypeLogin();
              this.getSmilePoint();
              this.checkingGamingProfile(this.mobileNumber);
      }
    }
    this.SS.skuDetails.subscribe((r) => {
      if (r) {
        this.sku = { ...r, ...this.sku };
        if (this.isArabic) {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceAr;
        } else {
          this.addonCMSUrl = this.sku?.tAndcAcceptanceEn;
        }
        if((r?.vasIsEligibleForAccountType && r?.vasIsEligibleForAccountType == 'POSTPAID') || (r?.vasIsEligibleForAccountType && r?.vasIsEligibleForAccountType == '1')){
          this.getProratedDetails(r);
        }
        this.cdr.detectChanges();
      }
      if (this.sku && this.sku?.listPrice) {
        this.getPrice();
      }
      if (this.sku && this.sku?.allowPayWithLoyaltyPaymentMode) {
        this.allowPayWithLoyaltyPaymentMode = true;
      }
	  this.getSkuAddonDetailRoaming(this.sku?.skuId);
    });
  }

  checkingGamingProfile(mobileNumber:any){
    this.PS.getGamingUserName(mobileNumber).subscribe((res:any)=>{
       if(res?.success == false){
        this.gamerProfileExist = false;
       }else if(res?.success == true && res?.username && res?.email){
        this.gamerProfileExist = true;
        this.SS.checkingGamingProfile.next(true);
        this.profileData = res;
        this.gamerId.setValue(res?.username || '');
        this.email.setValue(res?.email || '');
        this.APDS.gamerFormData = new GamerFormData();
        this.APDS.gamerFormData.gamerId = res?.username || '';
        this.APDS.gamerFormData.email  = res?.email || '';
        
        this.APDS.setEmail( res?.email || '');
        this.APDS.setGamerId(res?.username || '');
        this.APDS.ProfileExist = true;
       }
       else{
        this.gamerProfileExist = false;
        this.APDS.ProfileExist = false;
       }
    });
  }

  editGamingForm(){
    this.editForm = true;
  }

  saveGamingForm() {
    debugger
    if (this.profileData?.username == this.gamerId.value && this.profileData?.email == this.email.value) {
      this.editForm = false;
      this.gamerId.setValue((this.gamerId.value) ? this.gamerId.value : this.profileData?.username);
      this.email.setValue((this.email?.value) ? this.email?.value : this.profileData?.email);
    } else {
      let payload: any = { userName: this.gamerId.value || '', email: this.email.value }
      this.PS.validateGamingUser(payload).subscribe((res: any) => {
        if (res?.success && res?.usernameAvailable == false) {
          this.editForm = true;
          this.usernameNotAvailable = true;
          this.SS.arenaProAddonUsernameNotAvailable.next(true);
          this.usernameNotAvailable = true;
          this.gamerId.setValue((payload.userName) ? payload.userName : this.gamerId.value);
          this.email.setValue((payload?.email) ? payload?.email : this.email.value);
          this.cdr.detectChanges()
          return false;
        } else if (res?.success && res?.emailAvailable == false) {
          this.editForm = true;
          this.emailNotAvailable = true;
          this.SS.arenaProAddonEmailNotAvailable.next(true);
          this.usernameNotAvailable = true;
          this.gamerId.setValue((payload.userName) ? payload.userName : this.gamerId.value);
          this.email.setValue((payload?.email) ? payload?.email : this.email.value);
          this.cdr.detectChanges()
          return false;
        } else if (res?.success && res?.emailAvailable && res?.usernameAvailable) {
          this.editForm = false;
          // this.gamerId.setValue((this.gamerId.value) ? this.gamerId.value : this.profileData?.username);
          // this.email.setValue((this.email?.value) ? this.email?.value : this.profileData?.email);
          this.gamerId.setValue((payload.userName) ? payload.userName : this.gamerId.value);
          this.email.setValue((payload?.email) ? payload?.email : this.email.value);
          this.APDS.gamerFormData = new GamerFormData();
          this.APDS.gamerFormData.gamerId = (payload?.userName) ? payload?.userName : this.gamerId?.value
          this.APDS.gamerFormData.email = (payload?.email) ? payload?.email : this.email?.value
          
        this.APDS.setEmail( (payload?.email) ? payload?.email : this.email?.value);
        this.APDS.setGamerId((payload?.userName) ? payload?.userName : this.gamerId?.value);
        }
      });
    }
  }
  
  cancel(){
    this.editForm = false;
    this.SS.arenaProAddonUserDetails.next(true);
    if(this.profileData){
      this.gamerId.setValue(this.profileData?.username || '');
      this.email.setValue(this.profileData?.email || '');
      this.SS.arenaProAddonEmailAvailable.next(true);
      this.SS.arenaProAddonUsernameAvailable.next(true);
      this.cdr.detectChanges()
    }
  }

  continueButtonDisabled(){
    if(this.gamerProfileExist && !this.editForm){
      if(this.gamerId.valid && this.email.valid){
        return false;
      }else{
        return true;
      }
   }else if(this.gamerProfileExist && this.editForm){
    if(this.gamerId.valid && this.email.valid && this.confirmEmail.valid && this.email.value == this.confirmEmail.value){
      return false;
    }else{
      return true;
    }
   }else{
    if(this.gamerId.valid && this.email.valid && this.confirmEmail.valid && this.email.value == this.confirmEmail.value){
      return false;
    }else{
      return true;
    }
   }
  }

  increase() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.sku.maxQuantity > this.quantity) {
        this.quantity++;
        this.getPrice();
      }
    }
  }

  decrease() {
    if (this.sku && this.sku.maxQuantity) {
      if (this.quantity > 1) {
        this.quantity--;
        this.getPrice();
      }
    }
  }

  changeToggle(e: any) {
    this.autoRenew = !this.autoRenew;
  }
  onCheckoutImpression()
  {
    let product=[{
      name: this.sku?.displayName,
      id:  this.sku?.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
      price: +this.sku?.listPrice,
      brand:this.sku?.brand,
      category:'Roaming',
      user_env:this.UTS.getENV(),
      variant:'black',
      quantity:1
    }];

    let modal_data={
      event:'checkout',
      user_env: this.UTS.getENV(),
      ecommerce:{
        checkout:{
          actionField:{step:1, option:'Pass Selected Payment Option'},
          products:product
        }
     
      }
    }
    this.GAS.productClick_RoamingType(modal_data);
  }
  subscribeAddon() {
    this.subscribeDisabled = true;
    this.usernameNotAvailable = false;
    this.emailNotAvailable = false;
    let payload:any={userName:this.gamerId.value || '',email:this.email.value}
    if(this.gamerProfileExist == false){
      this.validateGaming(payload);
    }else if(this.gamerProfileExist == true) {
      if(this.gamerId.value !== this.profileData?.username){
        if(this.email.value == this.profileData?.email) {
          delete payload['email'];
        } 
        this.validateGaming(payload);
      }else{
         this.subscribeDisabled = false;
         this.showOptionalDevices = true;
      }
    }
  }

  validateGaming(payload:any){
    this.PS.validateGamingUser(payload).subscribe((res:any)=>{
      this.subscribeDisabled = false;
      if(res?.success && res?.usernameAvailable == false){
        this.usernameNotAvailable = true;
        this.SS.arenaProAddonUsernameNotAvailable.next(true);
      }else if(res?.success && res?.emailAvailable == false){
        this.emailNotAvailable = true;
        this.SS.arenaProAddonEmailNotAvailable.next(true);
      }else if(res?.success && !this.usernameNotAvailable && !this.emailNotAvailable){
        // redirect to controllers
        this.showOptionalDevices = true;
      }
    },(err:any)=>{
      this.subscribeDisabled = false;
    })
  }


  selectTime(time: any) {
    this.reminderTime = time;
  }
  selectAmPm(amPm: any) {
    this.reminderAmPm = amPm;
  }
  addAddon() {
    this.UTS.clearError();
    let link = '/addAddons';
    let specialInput = [
      {
       fieldName: 'username',
       fieldValue: this.gamerId.value,
      },
      {
        fieldName: 'gaming-email',
       fieldValue: this.email.value,
      }
    ]; //this.sku.specialInput ? this.sku.specialInput :
    localStorage.setItem('mobileNumber', this.mobileNumber);
    const payload = {
      accountNo: this.mobileNumber,
      accountNumber: null,
      addonId: this.sku.skuId,
      skuid: null,
      validate: false,
      type: 'ONE_TIME',
      quantity: this.quantity,
      specialInputs: specialInput,
      locale: this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      gamingAddon: false
    }
    // const ocrResponse = JSON.parse(localStorage.getItem('OCR_RESPONSE'));
    // if(this.sku && this.sku?.productType  && this.sku?.productType  == AppSettings.KIDS_ADDONS && ocrResponse && ocrResponse?.documentId){
    //   payload['kidEIDNumber'] = ocrResponse?.documentId;
    //   payload.specialInputs.push({
    //     fieldName: 'kidEIDNumber',
    //     fieldValue: ocrResponse?.documentId,
    //   })
    // }
    this.addonToCart();

    this.SKUDS.addAddons(payload, link).subscribe(
      (r: any) => {
        this.subscribeDisabled = false
        if (r) {
          if (r.success == true || r.success == 'true') {
            this.purchase(r.transactionNo, this.price);
            let success = {
              success: true,
              mobileNumber: this.mobileNumber,
              price: this.price,
              data: r,
            }
            this.SS.areanProAddonBuySuccessfully.next(success);
            localStorage.setItem('successAreanPro',JSON.stringify(success))
            if (r?.token) {
              localStorage.setItem('travelInsuranceToken', r?.token);
            }
            setTimeout(()=>{
              this.modalController.dismiss();
              this.router.navigateByUrl(
                '/addon/arenaprosuccess?lang=' +
                this.UTS.getLocaleLanguage()
              );
            },500)
            this.cdr.detectChanges();
          } else if (r.reason) {
            this.UTS.error(r.reason);
          } else {
            this.UTS.error(AppSettings.ERROR);
          }
        }
      },
      (e) => {
        this.subscribeDisabled = false
        let eMessage = '';
        if (e?.error?.errorDescription == AppSettings.ERROR_CRM_015) {
          // eligible for free parental addon subscription
          this.openBottomSheet(SuccessComponent, { isFreeParentalEligible: true });
        }
        if (this.UTS.getLocaleLanguage() == 'en') {
          if (
            e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
          ) {
            this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (
            e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00015 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00015
          ) {
            this.translate.get('ERROR_VAL_00015').subscribe((message) => {
              //   this.UTS.error(message);
              eMessage = message;
            });
          }
          else if (
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00002 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00013))
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_E222)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_E222))
          ) {

            this.translate.get('ERROR_VAL_E222').subscribe((message) => {
              eMessage = message;
            });
          }
          else {
            eMessage = e?.error?.errorDescription;
            //   this.UTS.error(e?.error?.errorDescription);
          }
        } else {
          if (
            e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
          ) {
            this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00015) {
            this.translate.get('ERROR_VAL_00015').subscribe((message) => {
              //  this.UTS.error(message);
              eMessage = message;
            });
          }
          else if (
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00002 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription.includes(AppSettings.VAL_00013)) ||
            (e?.error && e?.error?.message && e?.error?.message.includes(AppSettings.VAL_00013))
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (
            (e.error && e.error.errorDescription && e.error.errorDescription.includes(AppSettings.VAL_E222)) ||
            (e.error && e.error.message && e.error.message.includes(AppSettings.VAL_E222))
          ) {
            this.translate.get('ERROR_VAL_E222').subscribe((message) => {
              eMessage = message;
            });
          } else {
            eMessage = e?.error?.errorDescriptionAr;
            //   this.UTS.error(e?.error?.errorDescriptionAr);
          }
        }
        this.SS.addonBuyError.next(eMessage);
        this.SS.addonBuySuccessfully.next({ success: false, data: e });       
        this.cdr.detectChanges();

      }
    );
  }

  getPrice() {
    this.price = Number(
      this.sku.listPrice && this.parsePrice(this.sku.listPrice) > 0
        ? this.sku.listPrice
        : this.sku.recurringPrice &&
          this.parsePrice(this.sku.recurringPrice) > 0
          ? this.sku.recurringPrice
          : '0'
    ).toFixed(2);

    // this.price = Number(Number(this.sku.listPrice) * this.quantity).toFixed(2);
    this.cdr.detectChanges();
  }

  agreeToggle(e) {
    if (e.target.checked) {
      this.agreedOnterms = true;
    }
    else {
      this.agreedOnterms = false;
    }
    this.cdr.detectChanges();
  }

  agreeToggleLastExist(e) {
    this.isExpended = !this.isExpended;
    this.cdr.detectChanges();
  }

  onTermsClick()
  {
    this.isExpended = !this.isExpended;
    this.onTermsAndConditions();
  }
  onTermsAndConditions()
  {
    let modal={
      event:'b2b_fire_event',
      eventCategory:'roaming',
      eventAction:'termsandConditions',
      eventLabel:'Accept or Deny',
      typeOfRoaming:this.sku?.displayName,
      user_env:this.UTS.getENV()
    }
    this.GAS.onTermsAndConditions_Roaming(modal);
  }

  getAccountType() {
    this.PS.getAccountType(this.mobileNumber).subscribe(
      (res: any) => {
        if (res && res.accountType) {
          this.accountId = res.accountId;
          if (res.accountType.toLowerCase() == 'postpaid') {
            this.isATPostpaid = true;
          } else {
            this.isATPostpaid = false;
          }
        } else {
          this.isATPostpaid = false;
        }
        this.getQuickPay();
        this.checkControlline();
      },
      (e) => {
        this.UTS.log(e);
        this.checkControlline();
      }
    );
  }

  getAccountTypeLogin() {
    if (this.currentAccount && this.currentAccount.accountType == 'POSTPAID') {
      this.isATPostpaid = true;
    } else {
      this.isATPostpaid = false;
    }
    this.checkControlline();
  }

  checkControlline() {
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.subCategory) {
        const subCategory = q.subCategory;
        if (subCategory == AppSettings.CONTROL_LINE) {
          this.isControlLine = true;
          this.isATPostpaid = false;
        }
      }
      setTimeout(() => {
        if (this.sku?.displayName?.includes('Control Line')) {
          this.isControlLine = true;
          this.isATPostpaid = false;
        }
      }, 500);
    });
  }
  getCountries() {
    this.PS.getCountries(this.sku.skuId).subscribe(
      (res: any) => {
        if (res) {
          this.countries = res.countries;
          this.loadFlags();
        }
      },
      (e) => this.UTS.log(e)
    );
  }

  segmentChanged(val) {
    this.selectedFregement = val
  }

  chooseCountry(e) {
    this.countrycode = e.code;
  }

  loadFlags() {
    setTimeout(() => {
      let radios = document.getElementsByClassName('alert-radio-label');
      for (let index = 1; index < radios.length; index++) {
        let element = radios[index];
        element.innerHTML = element.innerHTML.concat(
          '<img class="country-image" style="width: 30px;height:16px;" src="' +
          this.countries[index - 1].flag +
          '" />'
        );
      }
    }, 2000);
  }

  addPaymentMethod(e) {
    this.paymentMethod = e.target.value;
  }

  addonToCart() {
    if (
      // this.categoryDetail &&
      // this.addon &&
      // (this.categoryDetail.categoryTitle ||
      //   this.categoryDetail.currentCategory) &&
      this.sku &&
      this.sku.displayName &&
      (this.sku.id || this.sku.skuId) &&
      this.sku.listPrice
    ) {
      const data :any = JSON.parse(localStorage.getItem('ProductCategory')) ;

      this.GAS.addToCart(
        // this.addon,
        // this.categoryDetail.categoryTitle
        //   ? this.categoryDetail.categoryTitle
        //   : this.categoryDetail.currentCategory,
        data?.cat,
        data?.product,
        this.sku.displayName,
        this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
        this.sku.listPrice,
        this.quantity,
        this.sku.brand
      );
    }
  }
  private purchase(TID, R) {
    if (
      this.categoryDetail &&
      this.addon &&
      (this.categoryDetail.categoryTitle ||
        this.categoryDetail.currentCategory) &&
      this.sku &&
      this.sku.displayName &&
      (this.sku.id || this.sku.skuId) &&
      this.sku.listPrice
    ) {
      this.GAS.purchase(
        this.addon,
        this.categoryDetail.categoryTitle
          ? this.categoryDetail.categoryTitle
          : this.categoryDetail.currentCategory,
        this.sku.displayName,
        this.sku.id ? this.sku.id : this.sku.skuId ? this.sku.skuId : '',
        this.sku.listPrice,
        this.quantity,
        this.sku.brand,
        TID ? TID : '',
        R
      );
    }
  }

  parsePrice(v) {
    if (Number(v)) {
      return Number(v);
    }
    return v;
  }

  getSmilePoint() {
    if (this.userInfo) {
      if (this.currentAccount && this.currentAccount.accountId) {
        this.accountId = this.currentAccount.accountId;
        this.PS.getAccountSummary(this.accountId).subscribe((resp: any) => {
          if (resp && resp.userAccount) {
            this.smilePointsOfUser = Number(resp.userAccount.accountSmilesPoints);
            if (resp.userAccount.currentBalance && Number(resp.userAccount.currentBalance) > 0) {
              this.currentBalance = Number(resp.userAccount.currentBalance);
            }
            else {
              this.currentBalance = 0;
            }
            this.showSmilesPoints = true;
            if (
              this.sku &&
              this.sku.smilesPoints &&
              (this.smilePointsOfUser) > (this.sku.smilesPoints.replace(/,/g , ''))
            ) {
              this.disabledSmilePoints = false;
            }
            //  }
            if (resp.userAccount.accountSmilesPoints) {
              this.isprimary = resp.userAccount.primary;
            }
          }
          this.getQuickPay();
        }, e => {
          this.getQuickPay();
        });
      }
    }
  }

  getQuickPay() {
    this.ACCS.getQuickPay(this.mobileNumber).subscribe((res: any) => {
      if (this.isATPostpaid == false) {
        if (res && res?.prepaidBalance) {
          this.currentBalance = Number(res?.prepaidBalance) > 0 ? Number(res?.prepaidBalance) : 0;
        }
      }
    }, err => {
      // this.currentBalance = 100;
    });
  }

  prepaidBalanceLessThanAddonCost() {
    const check = (this.sku?.listPrice && (this.currentBalance < this.parsePrice(this.sku?.listPrice))) ? true : (this.sku?.recurringPrice && (this.currentBalance < this.parsePrice(this.sku?.recurringPrice))) ? true : false;
    return check
  }


  getAccount() {
    let userImages = null;
    this.ACCS.getUserInfo().subscribe(
      (res) => {
        if (res && res?.imageBase64String) {
          userImages = res.imageBase64String
        }
        this.isUserLoggedIn = true;
        this.LoggedIn = true;
        this.cdr.detectChanges();
      },
      (e) => {
        this.isUserLoggedIn = false;
        this.LoggedIn = false;
        this.userInfo = null;
      }
    );
  }


  addAddonLoggedIn() {
    this.UTS.clearError();
    let link = '/addAddonsLoggedIn';

    let specialInput = []; //this.sku.specialInput ? this.sku.specialInput :
    localStorage.setItem('mobileNumber', this.mobileNumber);
    const payload = {
      'accountNo': this.mobileNumber,
      'accountNumber': this.mobileNumber,
      'addonId': this.sku.skuId,
      'skuid': this.sku.skuId,
      'validate': false,
      'type': this.autoRenew == true ? 'AUTO_RENEWAL' : 'ONE_TIME',
      'quantity': this.quantity,
      'specialInputs': specialInput,
      'locale': this.UTS.getLocaleLanguage().toString().toLocaleUpperCase(),
      'forwardCountryCode': null,
      'forwardCountryNumber': null,
      'reminder_date_time': null,
      'gamingAddon': true,
      'email': this.email.value,
      'username': this.gamerId.value
    };

    this.addonToCart();
    payload.accountNo = this.accountId;
    link = '/addAddonsLoggedIn';
    // const ocrResponse = JSON.parse(localStorage.getItem('OCR_RESPONSE'));
    // if(this.sku && this.sku?.productType  && this.sku?.productType  == AppSettings.KIDS_ADDONS && ocrResponse && ocrResponse?.documentId){
    //   payload['kidEIDNumber'] = ocrResponse?.documentId;
    // }
    this.SKUDS.addAddons(payload, link).subscribe(
      (r: any) => {
        this.subscribeDisabled = false
        if (r) {
          if (r.success == true || r.success == 'true') {
            this.purchase(r.transactionNo, this.price);
            let success = {
              success: true,
              mobileNumber: this.mobileNumber,
              price: this.price,
              data: r,
            }
            this.SS.areanProAddonBuySuccessfully.next(success);
            localStorage.setItem('successAreanPro',JSON.stringify(success))
            setTimeout(()=>{
              this.modalController.dismiss();
              this.router.navigateByUrl(
                '/addon/arenaprosuccess?lang=' +
                this.UTS.getLocaleLanguage()
              );
            },500)
            this.cdr.detectChanges();
          } else if (r.reason) {
            this.UTS.error(r.reason);
          } else {
            this.UTS.error(AppSettings.ERROR);
          }
        }
      },
      (e) => {
        this.subscribeDisabled = false
        let eMessage = '';
        if (this.UTS.getLocaleLanguage() == 'en') {
          if (
            e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
          ) {
            this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (
            e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00015 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00015
          ) {
            this.translate.get('ERROR_VAL_00015').subscribe((message) => {
              //   this.UTS.error(message);
              eMessage = message;
            });
          }
          else if (
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00002 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00013)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00013))
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (e?.error?.errorDescription?.includes(AppSettings.ERROR_VAL_00019)) {
            this.translate.get('ERROR_VAL_00019').subscribe((message) => {
              eMessage = message;
            });
          } else {
            eMessage = e?.error?.errorDescription;
            //   this.UTS.error(e?.error?.errorDescription);
          }
        } else {
          if (
            e?.error?.errorDescription == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_RTF_VAL_00080 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00080 ||
            e?.error?.message == AppSettings.ERROR_VAL_00080 ||
            e?.error?.newErrorCode == AppSettings.ERROR_VAL_00080
          ) {
            this.translate.get('ERROR_RTF_VAL_00080').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (e?.error?.errorDescription == AppSettings.ERROR_VAL_00015) {
            this.translate.get('ERROR_VAL_00015').subscribe((message) => {
              //  this.UTS.error(message);
              eMessage = message;
            });
          }
          else if (
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00011 ||
            e?.error?.message == AppSettings.ERROR_VAL_00002 ||
            e?.error?.errorDescription == AppSettings.ERROR_VAL_00002
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          }
          else if (
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00011)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_EAQTY)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00061)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00133)) ||
            (e?.error && e?.error?.errorDescription && e?.error?.errorDescription?.includes(AppSettings.VAL_00013)) ||
            (e?.error && e?.error?.message && e?.error?.message?.includes(AppSettings.VAL_00013))
          ) {
            this.translate.get('ERROR_VAL_00011').subscribe((message) => {
              eMessage = message;
            });
          } else if (e?.error?.errorDescription?.includes(AppSettings.ERROR_VAL_00019)) {
            this.translate.get('ERROR_VAL_00019').subscribe((message) => {
              eMessage = message;
            });
          } else {
            eMessage = e?.error?.errorDescriptionAr;
            //   this.UTS.error(e?.error?.errorDescriptionAr);
          }
        }
        this.SS.addonBuyError.next(eMessage);
        this.SS.addonBuySuccessfully.next({ success: false, data: e });
      }
    );

  }

  openDetailPage(sku: any) {
    this.SKUDS.set(sku);
    this.SDS.setAddon(this.addon);
    this.SS.resetVerification.next(true)
    setTimeout(() => {
      this.subscribe(sku);
    }, 500);
  }

  private subscribe(sku: any) {
    this.SS.skuDetails.next(sku);
    this.openBottomSheet(VerificationComponent, { type: this.addon });
  }

  async openBottomSheet(component: any, data,classes = 'verification-modal modal-fullscreen' ) {
    const modal = await this.modalController.create({
      component: component,
      showBackdrop: true,
      componentProps: { data: data },
      // mode: "ios",
      cssClass: classes,
    });
    return await modal.present();
  }

  async openLearnMoreBottomSheet(flag: String) {
    let URL = '';
    if(flag == 'learnMore'){
      URL = this.isArabic ? this.skuAddonDetails?.skus[0]?.learnMoreAr : this.skuAddonDetails?.skus[0]?.learnMoreEn;
    }
    else if(flag == 'termsCondition'){
      if (!this.skuAddonDetails) {
        let sku = localStorage.getItem("skuAddonDetails");
        if (sku) this.skuAddonDetails = JSON.parse(sku);
      }
      URL = this.isArabic ? this.skuAddonDetails?.skus[0]?.tAndcAcceptanceAr : this.skuAddonDetails?.skus[0]?.tAndcAcceptanceEn;

    }
    let payload = {
      URL, flag
    };
    const modal = await this.modalController.create({
      component: LearnMoreTravelInsuranceComponent,
      showBackdrop: true,
      backdropDismiss: true,
      cssClass: 'verification-modal modal-fullscreen ion-modal-uplift eand-partail-height-screen-bottom-70-mobile',
      componentProps: { data: payload },
    });
    return await modal.present();
  }
  getSkuAddonDetailRoaming(skuId){
    this.getSkuAddonDetails(skuId).then((response: any) => {
      if(response && response[0] && response[0].skus && response[0].skus[0] && response[0].skus[0].subgroupType === "TRAVEL_INSURANCE"){
		this.isTravelInsuranceAddon = true;
		this.skuAddonDetails = response[0];
	  }
	  else{
		this.isTravelInsuranceAddon = false;
	  }
	  localStorage.setItem("isTravelInsuranceAddon", this.isTravelInsuranceAddon.toString());
	  localStorage.setItem("skuAddonDetails", JSON.stringify(this.skuAddonDetails))
    })
  }

  async getSkuAddonDetails(skuId){
    const response = await this.SKUDS.getAddonSkuById(skuId)
    .toPromise()
    .catch((e) => this.UTS.log(e));
    return response;
  }

  removeComma(value:String){
    return  parseInt(value.replace(',',''));
  }

  get getCurrentDate(){
    return new Date();
  }

  get lastDate(){
    return new Date(this.getCurrentDate.getFullYear(), this.getCurrentDate.getMonth() + 1, 0);
  }

  get getDays(){
    return this.lastDate.getDate() - this.getCurrentDate.getDate() + 1;
  }

  learnMore(){
    this.openBottomSheet(
      ProRataPricesModalComponent,
      this.proratedData,
      'verification-modal modal-fullscreen'
    );
  }

  getProratedDetails(sku:any){
    this.PS.getProratedDetails(sku && sku?.skuId).subscribe((res:any)=>{
      console.log(res);
      if(res && res.proratedDetails && res.proratedDetails.length > 0){
       this.proratedData = res.proratedDetails || [];
      }
      
     },err=>{
      console.log(err);
     });
  }

  get getCurrentMonth(){
    if (this.lang == 'ar') {
      moment.locale('ar-kw');
      return moment(Date.now()).format('MMM');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('MMM'); // 13th April, 2020
    }
  }

  checkValue(service:any){
    const data = this.proratadValues.find((x:any)=>service?.totalValue && (service?.totalValue == x?.value))
    return data ? data : ''
   }

   

  private isAddonRecommended(skuId): boolean {
    let findRecommendedAddonAvailable = false;
    const ADDON_RECOMMENDATION_LIST = JSON.parse(localStorage.getItem('ADDON_RECOMMENDATION_LIST'));
    if(ADDON_RECOMMENDATION_LIST && ADDON_RECOMMENDATION_LIST?.length > 0){
      findRecommendedAddonAvailable = ADDON_RECOMMENDATION_LIST.find(x => x?.skuId == skuId) ? true : false;
    }
    return findRecommendedAddonAvailable;
  }
  checkSelectedType(seletedDevice:any){
    if(seletedDevice && seletedDevice?.data && seletedDevice?.type=='Sku'){
      this.selectedDevice = seletedDevice?.data
      const data = this.selectedDevice.filter((x:any)=>x?.isInStock == 'true') || [];
      localStorage.setItem('selectedDevices',JSON.stringify(data));
        let checkStock =this.selectedDevice.some(sku=> !sku?.isInStock || sku?.isInStock == "false");
        if(checkStock){
          this.showOptionalDevices = false; 
          this.showDeviceStocks = true;
        }else{
          this.arenaProaddonsAdd()
        }
      
    }else if(seletedDevice && seletedDevice?.type=='Addon'){
      this.arenaProaddonsAdd()
    }
  }
  arenaProaddonsAdd() {
    this.ACCS.getUserInfo().subscribe(
      (res) => {
        if (res && res?.login && res?.loginAccessToken) {
          this.isUserLoggedIn = true;
          this.LoggedIn = true;
          this.cdr.detectChanges();
          localStorage.setItem('isLoggedInSubscribe', 'true');
          this.addAddonLoggedIn()
        } else {
          this.isUserLoggedIn = false;
          this.LoggedIn = false;
          this.userInfo = null;
          this.cdr.detectChanges();
          localStorage.setItem('isLoggedInSubscribe', 'false');
          this.addAddon();
        }
      },
      (e) => {
        localStorage.setItem('isLoggedInSubscribe', 'false');
        this.isUserLoggedIn = false;
        this.LoggedIn = false;
        this.userInfo = null;
        this.cdr.detectChanges();
        this.addAddon();
      }
    );
  }
  backToOptinalDevice(backDevice){
    if(backDevice){
      localStorage.removeItem('selectedDevices');
      this.showOptionalDevices = true; 
      this.showDeviceStocks = false;
      this.selectedDevice =[];
    }
  }

  validateArenaForm(e) {
    this.emailNotAvailable = false;
    this.usernameNotAvailable = false;
    if (this.gamerId.valid == true &&
      this.email.valid == true &&
      this.confirmEmail.valid == true) {
        this.APDS.setEmail( this.email.value);
        this.APDS.setGamerId(this.gamerId.value);
      this.APDS.gamerFormData  = {
        gamerId: this.gamerId.value,
        email: this.email.value,
        confirmEmail: this.confirmEmail.value
      };
      this.SS.arenaProAddonUserDetails.next(true)
    }
  }

}
